import React from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import api_requests from "../../resources/api_requests";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { hide_loader, show_loader } from "../../actions/app";

const OrderCancelConfirm = ({
  order_id,
  close,
  title = "Are you sure you want to cancel your order?",
  sub_title = " Rider is already assigned for your order.",
  condition = "Cancellation charges will apply.",
  from = ''
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handle_cancel = async () => {
    try {
      dispatch(show_loader());
      const res = await api_requests.cancel_fulfilment_order(order_id);
      dispatch(hide_loader());
      close();
      if (from === 'order-success-modal') {
        navigate('/dashboard');
      } else {
        navigate(-1);
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-8"
      style={{ zIndex: 1000 }}
    >
      <div className="bg-white rounded-2xl shadow-3xl max-w-md overflow-x-hidden w-full">
        <div
          className="flex justify-end gap-2 items-center p-4"
          onClick={close}
        >
          <img src={ImageLinks.close} className="w-[14px] h-[14px]" />
        </div>
        <div className="flex flex-col px-10 py-10 pt-[10px] justify-center  text-center gap-8">
          <p className="px-6 font-custom text-xl font-semibold">{title}</p>

          <div className="rounded-lg bg-[#FFEAEC80] p-2.5">
            <p className="font-custom font-medium text-xs text-error">
              {sub_title}
            </p>
            <p className="font-custom font-medium text-xs text-error">
              {condition}
            </p>
          </div>
          <div className="flex w-full gap-3 justify-center px-6">
            <button
              onClick={close}
              className="font-custom text-base font-semibold btn w-[50%] text-secondary bg-white rounded-[30px] border-2	border-secondary"
            >
              Dismiss
            </button>
            <button
              onClick={handle_cancel}
              className="font-custom text-base font-semibold btn w-[50%] bg-primary text-white cursor-not-allowed rounded-[30px]"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCancelConfirm;
